import { currency } from 'globals/currency';
import { fixDecimal } from './general';

export function displayPrice(value: number) {
  return `${fixDecimal(value)} ${currency}`;
}